import script from "./flyBasicInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./flyBasicInfo.vue?vue&type=script&lang=ts&setup=true"

import "./flyBasicInfo.vue?vue&type=style&index=0&id=1ff5feec&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/K8S-上海阿里云Prod环境-UOTS-Front/frontend/front-uots-simulator/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ff5feec"]])

export default __exports__